export default class RevisionContractFlow {
  state: string;

  reviewType: string;

  lastModifiedBy: string;

  lastModifiedDate: string;

  historyEvents: Array<string>;

  constructor(obj: any = {}) {
    this.state = obj.state || '';
    this.reviewType = obj.reviewType || '';
    this.lastModifiedBy = obj.lastModifiedBy || '';
    this.lastModifiedDate = obj.lastModifiedDate || '';
    this.historyEvents = obj.historyEvents || [];
  }

  public static of(obj: any = {}): RevisionContractFlow {
    return new RevisionContractFlow(obj);
  }

  public static ofList(obj: any[]): RevisionContractFlow[] {
    return obj.map(this.of);
  }

  public isPending(): boolean {
    return this.state === 'PENDING';
  }

  public isAproved(): boolean {
    return this.state === 'APPROVED';
  }

  public isUndefined(): boolean {
    return this.state === 'UNDEFINED';
  }

  get isLevelReview(): boolean {
    return this.reviewType === 'REVISION_LEVEL_TWO';
  }
}
